import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { g as getDataTestId } from '../../getDataTestId-3b0cf239.js';
import '@alfalab/hooks';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';
import { l as layoutStyles } from '../../layout.module-ea8135d6.js';
import '../../../../base-modal/esm';

var desktopStyles = {"footer":"modal__footer_k7ls1","sticky":"modal__sticky_k7ls1","fullscreen":"modal__fullscreen_k7ls1","s":"modal__s_k7ls1","m":"modal__m_k7ls1","l":"modal__l_k7ls1","xl":"modal__xl_k7ls1"};
require('./desktop.css');

var styles = {"footer":"modal__footer_alvnp","sticky":"modal__sticky_alvnp","highlighted":"modal__highlighted_alvnp"};
require('./index.css');

var mobileStyles = {"footer":"modal__footer_5nmtu","sticky":"modal__sticky_5nmtu"};
require('./mobile.css');

var Footer = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, sticky = _a.sticky, _c = _a.layout, layout = _c === void 0 ? 'start' : _c, gap = _a.gap;
    var _d = useContext(ModalContext), footerHighlighted = _d.footerHighlighted, setHasFooter = _d.setHasFooter;
    var _e = useContext(ResponsiveContext), size = _e.size, view = _e.view, dataTestId = _e.dataTestId;
    useEffect(function () {
        setHasFooter(true);
    }, [setHasFooter]);
    return (React.createElement("div", { "data-test-id": getDataTestId(dataTestId, 'footer'), className: cn(styles.footer, className, layoutStyles[layout], gap && layoutStyles["gap-".concat(gap)], (_b = {},
            _b[styles.highlighted] = sticky && footerHighlighted,
            _b[styles.sticky] = sticky,
            _b[desktopStyles.footer] = view === 'desktop',
            _b[desktopStyles.sticky] = view === 'desktop' && sticky,
            _b[desktopStyles[size]] = view === 'desktop',
            _b[mobileStyles.footer] = view === 'mobile',
            _b[mobileStyles.sticky] = view === 'mobile' && sticky,
            _b)) }, children));
};

export { Footer };
